export const getInitials = (str: string, count = 2) => {
  // Ensure we return at least one initial from this function
  const floorCount = Math.max(count, 1)
  return str
    .split(/\s/)
    .map((ss) => ss.substring(0, 1).toUpperCase())
    .filter((v) => !!v)
    .slice(0, floorCount)
    .join('')
}
